import React from 'react';
import { Table, Card, Typography, Tag, Tabs } from 'antd';
const { Title, Text } = Typography;

const v2Data = [
  { key: 'v2-1', cloudId: 'cn-v2-01', cloudName: 'China-V2-Main', region: '国内', domain: 'cn-v2.hemeng.cloud' },
  { key: 'v2-2', cloudId: 'ap-v2-01', cloudName: 'AsiaPacific-V2', region: '亚太', domain: 'ap-v2.hemeng.cloud' },
  { key: 'v2-3', cloudId: 'na-v2-01', cloudName: 'NorthAmerica-V2', region: '北美', domain: 'na-v2.hemeng.cloud' },
];

const v3Data = [
  { key: 'v3-1', cloudId: 'cn-v3-01', cloudName: 'China-V3-Main', region: '国内', domain: 'cn-v3.hemeng.cloud' },
  { key: 'v3-2', cloudId: 'cn-v3-02', cloudName: 'China-V3-Backup', region: '国内', domain: 'cn-v3-bak.hemeng.cloud' },
  { key: 'v3-3', cloudId: 'ap-v3-01', cloudName: 'AsiaPacific-V3', region: '亚太', domain: 'ap-v3.hemeng.cloud' },
  { key: 'v3-4', cloudId: 'eu-v3-01', cloudName: 'Europe-V3', region: '亚太', domain: 'eu-v3.hemeng.cloud' },
  { key: 'v3-5', cloudId: 'na-v3-01', cloudName: 'NorthAmerica-V3', region: '北美', domain: 'na-v3.hemeng.cloud' },
];

const columns = [
  { title: 'CloudID', dataIndex: 'cloudId', key: 'cloudId', width: 160, render: (t) => <Text copyable style={{ fontFamily: 'monospace' }}>{t}</Text> },
  { title: 'CloudName', dataIndex: 'cloudName', key: 'cloudName', width: 200 },
  { title: '所属区域', dataIndex: 'region', key: 'region', width: 100, render: (v) => {
    const color = { '国内': 'blue', '亚太': 'green', '北美': 'orange' };
    return <Tag color={color[v] || 'default'}>{v}</Tag>;
  }},
  { title: '域名', dataIndex: 'domain', key: 'domain', render: (t) => <Text copyable style={{ fontFamily: 'monospace', fontSize: 13 }}>{t}</Text> },
];

const ServiceRegion = () => (
  <div style={{ padding: 24 }}>
    <div style={{ marginBottom: 16 }}><Title level={4}>服务区域</Title></div>
    <Card bordered={false} style={{ borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.02)' }}>
      <Tabs items={[
        { key: 'v2', label: `V2 (${v2Data.length})`, children: <Table columns={columns} dataSource={v2Data} rowKey="key" pagination={false} /> },
        { key: 'v3', label: `V3 (${v3Data.length})`, children: <Table columns={columns} dataSource={v3Data} rowKey="key" pagination={false} /> },
      ]} />
    </Card>
  </div>
);

export default ServiceRegion;
